module.exports = __webpack_public_path__ + "static/img/yshImg.e478e94c.png";